<template>
    <div class="user-act-analyse">
        <!--顶部-->
        <div class="action-header">
            <!--背景色-->
            <img src="/icon_web_banner_tec.png" class="header-img" v-if="userState==='teacher'">
            <img src="/icon_web_banner_stu.png" class="header-img" v-if="userState==='student'">
            <!--用户角色切换-->
            <div class="user-state-change">
                <div class="user-act-analyse-tab" :class="userState==='teacher'?'show-teacher-state':''"
                     @click="changeUserState('teacher')">教师全过程行为分析
                </div>
                <div class="user-act-analyse-tab" :class="userState==='student'?'show-student-state':''"
                     @click="changeUserState('student')">学生行为分析
                </div>
            </div>
        </div>
        <!--内容-->
        <div class="action-content">
            <!--课前行为数据-->
            <div class="action-item pre-class-action">
                <img src="/icon_web_before.png" class="action-img-left">
                <div class="action-title-left">课前行为数据</div>
                <div class="action-charts-right">
                    <!--用户课前行为分析-->
                    <tran-histogram
                            :showTitle=false
                            :clickCharts=true
                            :isHideData=true
                            :yAxisLine=false
                            :xAxisTick=false
                            :yAxisTick=false
                            :ySplitLine=false
                            :dataRemindPosition="'right'"
                            :fontColor="'#999'"
                            :fontSize="'14px'"
                            :yAxisType="'category'"
                            :tooltipHead="'使用：'"
                            :tooltipCompany="'次'"
                            :chartsId="'user-before-action-analyse'"
                            :height="'368px'"
                            ref="beforeActRef"
                            @click-more-data="clickMoreData"
                    ></tran-histogram>
                </div>
            </div>
            <!--课中行为数据-->
            <div class="action-item on-class-action">
                <img src="/icon_web_on.png" class="action-img-right">
                <div class="action-title-right">课中行为数据</div>
                <div class="action-charts-left">
                    <!--用户课前行为分析-->
                    <histogram-charts
                            :showTitle=false
                            :clickCharts=true
                            :isDipData=true
                            :xAxisLine=false
                            :isShowYaxis=false
                            :xAxisTick=false
                            :xSplitLine=false
                            :ySplitLine=false
                            :fontColor="'#999'"
                            :fontSize="'14px'"
                            :dataRemindPosition="'top'"
                            :tooltipHead="'使用：'"
                            :tooltipCompany="'次'"
                            :chartsId="'user-on-action-analyse'"
                            :height="'368px'"
                            :colorArr="onActionChartsColor"
                            ref="onActRef"
                            @click-more-data="clickMoreData"
                    ></histogram-charts>
                </div>
            </div>
            <!--课后行为数据-->
            <div class="action-item after-class-action">
                <img src="/icon_web_after.png" class="action-img-left">
                <div class="action-title-left">课后行为数据</div>
                <div class="action-charts-right">
                    <pie-charts
                            :isShowMore=false
                            :showTitle=false
                            :isClickCharts=true
                            :height="'360px'"
                            :fontColor="'#999'"
                            :pieRadiusArr="pieRadiusArr"
                            :chartsId="'user-after-action-analyse'"
                            :colorArr="afterActionChartsColor"
                            :pieChartsName="'行为分析'"
                            ref="afterActRef"
                            @click-more-data="clickMoreData"
                    ></pie-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {findUserActionAnalyseData, regionUserActionData} from "../../../service/bigDataApi.js";

    const TranHistogram = () => import("../../../components/charts/TranHistogram.vue");//横向柱状图
    const HistogramCharts = () => import("../../../components/charts/newHistogramCharts.vue");//竖向柱状图
    const PieCharts = () => import("../../../components/charts/PieCharts.vue");//竖向柱状图
    export default {
        name: "user-action-analyse",
        components: {
            TranHistogram,
            HistogramCharts,
            PieCharts
        },
        data() {
            return {
                userState: this.$route.query.userState,
                schoolId: this.$route.query.schoolId,
                schoolName: this.$route.query.schoolName,
                form: this.$route.query.form,
                barColorArr: [],
                barFontColor: [],
                //教师行为分析
                teacherActionList: [],
                //学生行为分析
                studentActionList: [],
                //用户课前行为集合
                beforeUserActionList: [],
                //用户课中行为集合
                onUserActionList: [],
                //用户课后行为集合
                afterUserActionList: [],
                //课中行为分析图表颜色集合
                onActionChartsColor: [
                    {offset: 0.5, color: "#FFBA8D"},
                    {offset: 1, color: "#FC686F"}
                ],
                //课后行为分析图表颜色集合
                afterActionChartsColor: ["#2DC0D3", "#C587FF", "#FC686F", "#99D163", "#FFB239", "#46AAFF", '#F36D81', '#E581AD', '#E2BFE9', '#7672ED'],
                //课后行为分析环形图半径
                pieRadiusArr: ['30%', '60%']
            }
        },
        methods: {
            /**
             * 切换用户状态
             */
            changeUserState(val) {
                this.userState = val;
                let data = this.userState == 'teacher' ? this.teacherActionList : this.studentActionList;
                //处理教师行为
                this.handleUserBehavior(data);
            },
            /**
             * 获取学校用户的行为分析数据
             */
            async getSchoolUserActionAnalyseData() {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId
                };
                let resultData = await findUserActionAnalyseData(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.teacherActionList = resultData.teaBehaviorType;
                _this.studentActionList = resultData.stuBehaviorType;
                let data = _this.userState == 'teacher' ? _this.teacherActionList : _this.studentActionList;
                //处理用户行为数据
                _this.handleUserBehavior(data);
            },
            /**
             * 处理用户行为数据
             */
            handleUserBehavior(data) {
                let _this = this;
                //初始化数据
                _this.beforeUserActionList = [];
                _this.onUserActionList = [];
                _this.afterUserActionList = [];
                for (let i = 0; i < data.length; i++) {
                    if (data[i].type == 1) {
                        _this.beforeUserActionList.push(data[i]);
                    } else if (data[i].type == 2) {
                        _this.onUserActionList.push(data[i]);
                    } else if (data[i].type == 3) {
                        _this.afterUserActionList.push(data[i]);
                    }
                }
                //处理数据
                _this.handleDate(_this.beforeUserActionList, '1');
                _this.handleDate(_this.onUserActionList, '2');
                _this.handleDate(_this.afterUserActionList, '3');
            },
            handleDate(data, type) {
                let _this = this;
                let xdataArr = [];
                let seriesDataArr = [];
                for (let i = 0; i < data.length; i++) {
                    let obj = {};
                    obj.value = data[i].count;
                    obj.name = data[i].func_name;
                    obj.id = data[i].func_code;
                    xdataArr.push(data[i].func_name);
                    seriesDataArr.push(obj);
                }
                _this.$nextTick(() => {
                    //渲染图表
                    setTimeout(function () {
                        if (type == 3) {
                            _this.$refs.afterActRef.initDataSource(data, xdataArr, seriesDataArr);
                        } else if (type == 1) {
                            _this.$refs.beforeActRef.initDataSource(data.length > 0, xdataArr, seriesDataArr);
                        } else {
                            _this.$refs.onActRef.initDataSource(data.length > 0, xdataArr, seriesDataArr);
                        }
                    }, 300);
                })
            },
            /**
             * 获取代理商用户的行为分析数据
             */
            async getAgentUserActionAnalyseData(type) {
                let _this = this;
                let params = {
                    agentId: _this.$store.getters.agentId,
                    type: type
                };
                let resultData = await regionUserActionData(params).catch(function (error) {
                    _this.$Message.error(error.message);
                });
                _this.teacherActionList = resultData.teaBehaviorType;
                _this.studentActionList = resultData.stuBehaviorType;
                let data = _this.userState == 'teacher' ? _this.teacherActionList : _this.studentActionList;
                //处理用户行为数据
                _this.handleUserBehavior(data);
            },
            /**
             * 根据来源差数据
             */
            queryDataByForm() {
                if (this.form == 'school') {
                    //获取学校用户行为分析数据
                    this.getSchoolUserActionAnalyseData();
                } else {
                    //获取代理商用户行为分析数据
                    this.getAgentUserActionAnalyseData();
                }
            },
            /**
             * 点击查看更多数据
             */
            clickMoreData(chartType, row) {
                this.$router.push({
                    name: 'useractiondetails',
                    query: {
                        schoolId: this.schoolId,
                        schoolName: this.schoolName,
                        funcCode: chartType == 'pie' ? row.data.id : row,
                        from: this.userState == 'teacher' ? 'tea' : 'stu',
                        form: this.form  //各校还是代理商的数据展板
                    }
                })
            },
            /**
             * 面包屑
             */
            setCurrentPath() {
                let currentPathArr=[];
                if(this.$route.query.isFresh==1){
                    currentPathArr = [
                        {
                            title: "首页",
                            path: "regiondataboard",
                            name: "regiondataboard",
                            query: {
                                agentId: this.$route.query.agentId || this.$store.getters.agentId,
                                agentName: this.$route.query.agentName || this.$store.getters.agentName
                            }
                        },
                        {
                            title: this.$route.query.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "各校用户行为分析",
                            path: "",
                            name: "useractionanalyse"
                        }
                    ];
                }else{
                    currentPathArr = [
                        {
                            title: "首页",
                            path: this.$route.query.params=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                            name: this.$route.query.params=='75047a8a0990480f8abf3a39bc25f1ab'?'cloudschooldataboard':"schooldataboard",
                            params: {
                                schoolId: this.$route.query.schoolId,
                            }
                        },
                        {
                            title: this.$route.query.schoolName,
                            path: "",
                            name: "schoolName"
                        },
                        {
                            title: "各校用户行为分析",
                            path: "",
                            name: "useractionanalyse"
                        }
                    ];
                }
                this.$store.commit("setCurrentPath", currentPathArr);
            }
        }
        ,
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.form = vm.$route.query.form;
                vm.schoolId = vm.$route.query.schoolId;
                vm.queryDataByForm();
                vm.setCurrentPath();
            })
        },
        // mounted() {
        //     this.queryDataByForm();
        // }
    }
</script>

<style scoped lang="scss">
    @import "../../../style/detailPage";

</style>
<style lang="scss">
    .ivu-card:hover {
        box-shadow: 0 0 0 0;
    }

    .ivu-card {
        border: 0;
    }

</style>
